module.exports = __webpack_public_path__ + "static/img/arachas2.abc0a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/arachas2.png
// module id = OXlA
// module chunks = 0